<template>
    <div class="componente-principal">
        <br/>
        <botao 
            type="button" 
            font_awesome_class="far fa-calendar-alt" 
            label="Regime de Caixa"
            @click.native="receitasDespesas('caixa')"/><br/>

        <botao 
            type="button" 
            font_awesome_class="far fa-calendar-alt" 
            label="Regime de Competência"
            @click.native="receitasDespesas('compet')"/><br/>


        
    </div>
</template>

<script>

import Botao from '@/components/shared/Botao.vue';
    
export default {
    name: 'receitasDespesas',
    components: {
        Botao
    },
    methods:{
        receitasDespesas(regime){
            this.$router.push(`/receitasdespesas/${regime}`);
        }

    }

}
</script>

